export default () => {
  let video = document.querySelector('.c-header__video[data-video]');

  if (video === null) {
    return;
  }

  const tag = document.createElement('script');
  tag.src = `${window.location.protocol}//www.youtube.com/iframe_api`;

  const firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

  window.onYouTubeIframeAPIReady = () => {
    const videoId = video.getAttribute('data-video');
    // eslint-disable-next-line
    let player = new window.YT.Player(video, {
      playerVars: {
        muted: 1,
        autoplay: 1,
        controls: 0,
        showinfo: 0,
        modestbranding: 1,
        loop: 1,
        fs: 0,
        rel: 0,
        cc_load_policy: 0,
        iv_load_policy: 3,
        autohide: 1,
        disablekb: 1,
        enablejsapi: 1,
      },
      events: {
        onReady: () => {
          video = document.querySelector('.c-header__video[data-video]');
          player.loadPlaylist([videoId]);
          player.setLoop(true);
          player.mute();
        },
        onStateChange: event => {
          if (event.data === window.YT.PlayerState.PLAYING) {
            video.classList.add('is-active');
          }
        },
      },
    });
  };
};



// WEBPACK FOOTER //
// ./src/scripts/modules/header-video.js